<template>
  <div class="container">
    <div class="header">
      <div class="title">Accès privé</div>
      <div class="highlighted">Partenaires et clients</div>
    </div>
    <form
      v-if="is_token_valid"
      @submit.prevent="resetPassword"
      class="login-form"
    >
      <h3 class="login-form-header">Réinitialisez votre mot de passe</h3>
      <Password
        class="login-form-div"
        v-model="password"
        @passwordvalid="(statepwd) => (passwordValid = statepwd)"
      />
      <div class="login-footer">
        <div class="no-account">
          <router-link class="" to="/private">
            Retour à la connexion
          </router-link>
        </div>
        <button class="login-button" type="submit">
          Réinitialisez votre mot de passe
        </button>
      </div>
    </form>
    <div v-else>
      Votre token n'est plus valide, ou a déjà été utilisé.
      <router-link class="" to="/private"> Revenir à la connexion</router-link>
    </div>
  </div>
</template>

<script>
import AuthService from "../../services/AuthService";
import { onMounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import Password from "../../components/LoggedComp/Password.vue";
export default {
  name: "Login2",
  components: {
    Password,
  },
  setup() {
    const toast = useToast();
    const router = useRouter();
    const route = useRoute();

    const is_token_valid = ref(true);

    const password = ref("");
    const passwordValid = ref(false);

    async function resetPassword() {
      try {
        if (!passwordValid.value) {
          toast.error("Le mot de passe n'est pas valide");
          return;
        }
        const token = await AuthService.changePassword(
          password.value,
          route.params.token
        );
        toast.success("Votre mot de passe a bien été changé.", {
          position: "bottom-center",
        });

        localStorage.setItem("token", token);
        router.push("/private/me");
      } catch (_e) {
        toast.error("Une erreur est survenue", {
          position: "bottom-center",
        });
      }
    }

    onMounted(async () => {
      is_token_valid.value = await AuthService.checkTokenValidity(
        route.params.token // token de vérification pour changer son mot de passe
      );
      if (localStorage.getItem("token") != null) {
        // rien à voir ici c'est le token de session
        router.push("/private/me");
      }
    });

    return {
      password,
      resetPassword,
      is_token_valid,
      passwordValid,
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.title {
  padding-bottom: 0 !important;
}
.highlighted {
  text-align: center;
  padding-top: 0 !important;
}

.login-form {
  display: flex;
  flex-direction: column;
  border: none;
  min-width: 20rem;
  width: 28.75rem;
  border-radius: 6px;
  padding: 35px 40px;
  box-shadow: 1px 1px 4px rgba($color: #000000, $alpha: 0.15);
  .login-form-header {
    color: var(--mainBlue);
    font-size: 1.15rem;
    font-weight: 700;
    padding-top: 1em;
    padding-bottom: 1em;
  }
  .login-form-div {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    .forgot-password {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 0.2em;
      font-size: 0.9em;
    }
    label {
      font-size: 1em;
      padding-top: 0.5em;
    }
    input {
      padding: 1em;
      margin-bottom: 0.625rem;
      height: 3.125;
      width: 100%;
      border: 1px solid #c4c4c4;
      border-radius: 3px;
      font-size: 0.875rem;
    }
  }
  .login-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 3rem;
    padding-bottom: 1em;
    .no-account {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 100%;
    }
    .login-button {
      color: white;
      min-width: 153px; // ? ça sort d'où
      padding: 1em;
      background-color: var(--mainBlue);
      border: none;
      font-size: 1em;
      font-weight: bolder;
    }
  }
}
</style>